/**
 * created by lei lei
 * 投递资源管理
 *
 */
import {formateData, headers} from "./index";
import request from "../base/request";
import {applicationName} from "../utils";
let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    queryStoryUnSaveResource: host + 'v3/zyk/queryStoryUnSaveResource',//获取稿件列表
    queryClueUnSaveResource: host + 'v3/zyk/queryClueUnSaveResource',//获取线索列表
    queryInterviewUnSaveResource: host + 'v3/zyk/queryInterviewUnSaveResource',//获取活动列表
    queryDouyinUnSaveResource: host + 'v3/zyk/queryDouyinUnSaveResource',//获取抖音列表
    queryWeiboUnSaveResource: host + 'v3/zyk/queryWeiboUnSaveResource',//获取微博列表
    getFileUploadPathConfigList: host + 'fileUploadPathConfig/getFileUploadPathConfigList',//获取入库配置
    getRootDir: host + '/v3/zyk/getRootDir',// 获取入库根目录
    updateStatus: host + 'fileUploadPathConfig/updateStatus',//自动入库和非自动入库修改状态
    manualSaveAll: host + 'v3/zyk/manualSaveAll',//保存入库
};

export const queryStoryUnSaveResource = (body,callBack) => {  //获取稿件列表
    request({url:Apis.queryStoryUnSaveResource, method:"post", body, callBack});
};
export const queryClueUnSaveResource = ( body,callBack) => {  //获取线索列表
    request({url:Apis.queryClueUnSaveResource, method:"post", body, callBack});
};
export const queryInterviewUnSaveResource = (body,callBack) => {  //获取活动列表
    request({url:Apis.queryInterviewUnSaveResource, method:"post", body, callBack});
};
export const queryDouyinUnSaveResource = ( body,callBack) => {  //获取抖音列表
    request({url:Apis.queryDouyinUnSaveResource, method:"post", body, callBack});
};
export const queryWeiboUnSaveResource = (body,callBack) => {  //获取微博列表
    request({url:Apis.queryWeiboUnSaveResource, method:"post", body, callBack});
};
export const getFileUploadPathConfigList = (body,callBack) => {  //获取入库配置
    request({url:Apis.getFileUploadPathConfigList, method:"post", body, callBack});
};
export const getRootDir = (callBack) => {  //获取入库配置
    request({url:Apis.getRootDir, callBack});
};
export const updateStatus = (body,callBack) => {  //修改入库方式
    request({url:Apis.updateStatus, method:"post", body, callBack});
};
export const manualSaveAll = (body,callBack) => {  //修改入库方式
    request({url:Apis.manualSaveAll, method:"post", body, callBack});
};

export const getStoryById = (storyId, callBack)=> {
    let url = "/cm-sites-pms/storyNew/show";
    request({url, method:"post", body:{storyId}, callBack});
};
export const newsclue = (id, callBack)=> {
    let url = "/cm-sites-pms/newsclue/getById";
    request({url, method:"post", body:{id}, callBack});
};
export const interview = (interviewId, callBack)=> {
    let url = "/cm-sites-pms/interview/getById";
    request({url, method:"post", body:{interviewId}, callBack});
};
export const douyin = (id, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/douyin/getById";
    request({url, body:{id}, callBack});
};

export const weibo = (id, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/weibo/getById";
    request({url, body:{id}, callBack});
};

export const getDeparment = (deptId, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/dept/getById";
    request({url, body:{deptId}, callBack});
};
export const getByAccount = (account, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/user/getByAccount";
    request({url, body:{account}, callBack});
};